var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var hideShowFiltersEvent = false;
var clearAllFilterButton = false;
let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
if(clearAllButton){
  clearAllFilterButton = true;
}
function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });
    var grid_layout_collection = Cookies.get('grid_layout_collection');
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-5" && grid_layout_collection != "grid-layout-4") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-2")
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-5" && grid_layout_collection != "grid-layout-4") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-3")
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-5"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-5")
            }
        }
        updateGridView(parent);
    }
}

function hideShowFilters() {
    var filterHeading = document.getElementById('filterHeading');
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            if (fbFilterDrawerIsOpen()) { fbFilterDrawerClose(false); }
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
        }
    }
    fbFilterHeadingState();
    if (hideShowFiltersEvent == false ) {
        if (filterHeading) {
            filterHeading.addEventListener("click", (e) => {
                e.preventDefault();
                if (window.innerWidth > 767) {
                    if (filterContainer && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(filterContainer, 'filters-toggle');
                            setTimeout(fbFilterHeadingState, 50);
                        }
                    }
                } else {
                    fbFilterDrawerOpen(filterHeading);
                }
            });
        }
        hideShowFiltersEvent = true;
    }
}
function hideFilters(){ /* fixes 71: handled by the delegated click listener (#cancelFilters) */ }
/* Claude fixes 72 (P33 step 1): the phone filter drawer is a real modal dialog while it is open: role=dialog, aria-modal,
   labelled by its 'Filter' heading, focus moves to the 'Luk filtre' button, Tab is trapped inside, Esc closes it, and focus
   returns to the 'Filter' button. On desktop the sidebar stays a plain region (the attributes are removed). */
var fbDrawerReturn = null;
function fbFilterDrawerIsOpen() {
    var fs = document.getElementById('filterSideBar');
    return !!(fs && fs.classList.contains('active') && document.body.classList.contains('open-filter-popup'));
}
function fbFilterHeadingState() {
    var h = document.getElementById('filterHeading');
    if (!h) { return; }
    var c = document.getElementById('CollectionProductsContainer');
    if (window.innerWidth > 767 && !h.classList.contains('filters-drawer-toggle')) {
        h.removeAttribute('role'); h.removeAttribute('tabindex'); h.removeAttribute('aria-expanded');
        return;
    }
    h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-controls', 'filterSideBar');
    var open = window.innerWidth > 767 ? !!(c && !c.classList.contains('filters-toggle')) : fbFilterDrawerIsOpen();
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
}
function fbDrawerFocusables(fs) {
    var list = fs.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (el) { return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; });
}
function fbFilterDrawerOpen(trigger) {
    var fs = document.getElementById('filterSideBar');
    if (!fs) { return; }
    fbDrawerReturn = trigger || document.activeElement;
    fs.classList.add('active');
    document.body.classList.add('open-filter-popup');
    document.body.classList.add('open-filter-sort');
    fs.setAttribute('role', 'dialog');
    fs.setAttribute('aria-modal', 'true');
    if (document.getElementById('fbFilterDialogTitle')) { fs.setAttribute('aria-labelledby', 'fbFilterDialogTitle'); } else { fs.setAttribute('aria-label', 'Filtre'); }
    fs.setAttribute('tabindex', '-1');
    fbFilterHeadingState();
    setTimeout(function () {
        var c = document.getElementById('cancelFilters');
        try { ((c && c.getClientRects().length) ? c : fs).focus({ preventScroll: true }); } catch (err) {}
    }, 60);
}
function fbFilterDrawerClose(returnFocus) {
    var fs = document.getElementById('filterSideBar');
    if (fs) {
        fs.classList.remove('active');
        fs.removeAttribute('role'); fs.removeAttribute('aria-modal'); fs.removeAttribute('aria-labelledby'); fs.removeAttribute('aria-label');
    }
    document.body.classList.remove('open-filter-popup');
    document.body.classList.remove('open-filter-sort');
    fbFilterHeadingState();
    var r = fbDrawerReturn;
    fbDrawerReturn = null;
    if (returnFocus !== false) {
        if (!r || !document.body.contains(r)) { r = document.getElementById('filterHeading'); }
        if (r && r.focus) { try { r.focus({ preventScroll: true }); } catch (err) {} }
    }
}
function fbFilterKeydown(e) {
    var t = e.target;
    var key = e.key;
    if ((key === 'Enter' || key === ' ' || key === 'Spacebar') && t && t.id === 'filterHeading') {
        e.preventDefault();
        t.click();
        return;
    }
    if (key === 'Escape' || key === 'Esc') {
        if (fbFilterDrawerIsOpen()) { e.preventDefault(); fbFilterDrawerClose(); return; }
        var sortMenu = document.getElementById('sort__list');
        if (sortMenu && sortMenu.classList.contains('active')) {
            e.preventDefault();
            sortMenu.classList.remove('active');
            if (window.innerWidth > 767) { DOMAnimations.slideUp(sortMenu); } else { document.body.classList.remove('open-filter-sort'); }
            var sb = document.querySelector('.collection-sortby-selected');
            if (sb) { try { sb.focus({ preventScroll: true }); } catch (err) {} }
        }
        return;
    }
    if (key === 'Tab' && fbFilterDrawerIsOpen()) {
        var fs = document.getElementById('filterSideBar');
        var items = fbDrawerFocusables(fs);
        if (!items.length) { e.preventDefault(); fs.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        var a = document.activeElement;
        if (!fs.contains(a)) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && (a === first || a === fs)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
}
/* Claude fixes 71 (P22 step 5): every filter, sort and layout control is now a delegated listener bound ONCE on document
   (fbBindFilterDelegates). Before, applyFilters() re-bound click/change listeners on every resize and after every filter fetch,
   so one tap could fire several fetches. Stale fetches are aborted (getFilterData), resize is debounced and no longer re-binds,
   and each price slider gets its noUiSlider and change handler once. */
var fbFilterDelegatesBound = false;
var fbFilterCtrl = null;
var fbFilterSeq = 0;
function fbFilterSectionId() {
    var c = document.getElementById('CollectionProductsContainer');
    return c ? c.dataset.id : '';
}
function fbBindFilterDelegates() {
    if (fbFilterDelegatesBound) { return; }
    fbFilterDelegatesBound = true;
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) { return; }
        var el;
        if ((el = t.closest('.sort-grid-icon'))) { fbLayoutClick(e, el); return; }
        if ((el = t.closest('a.yv-applied-filter-remove'))) {
            if (!document.getElementById('CollectionProductsContainer')) { return; }
            e.preventDefault();
            getFilterData(el, fbFilterSectionId(), el.getAttribute('href'));
            return;
        }
        if ((el = t.closest('#FiltersForm .filters-expand'))) { fbShowMoreClick(e, el); return; }
        if ((el = t.closest('#cancelFilters'))) {
            e.preventDefault();
            fbFilterDrawerClose();
            return;
        }
        if ((el = t.closest('.collection-sortby-selected'))) { fbSortMenuToggle(e); return; }
        if ((el = t.closest('.close-sort'))) {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (window.innerWidth < 768 && sortMenu) {
                sortMenu.classList.remove('active');
                document.body.classList.remove('open-filter-sort');
            }
            return;
        }
        if ((el = t.closest('.yv-filter-title'))) {
            var filterContent = el.nextElementSibling;
            if (filterContent) { filterContent.classList.toggle('active'); }
            return;
        }
        if (t.matches && t.matches('#FiltersForm input[type=checkbox], #FiltersForm input[type=radio]') && !t.matches('[data-sort-by]')) {
            if (window.innerWidth > 767 && document.getElementById('CollectionProductsContainer')) {
                getFilterData(t, fbFilterSectionId());
            }
        }
    });
    document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.matches) { return; }
        if (t.matches('[name="sort_by"][data-sort-by]')) { fbSortChange(e, t); return; }
        if (t.matches('#FiltersForm input[type=number]') && window.innerWidth > 767 && document.getElementById('CollectionProductsContainer')) {
            getFilterData(t, fbFilterSectionId());
        }
    });
    document.addEventListener('keydown', fbFilterKeydown);
    document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || f.id !== 'FiltersForm' || !document.getElementById('CollectionProductsContainer')) { return; }
        if (window.innerWidth <= 767) {
            e.preventDefault();
            getFilterData(f, fbFilterSectionId());
        }
    });
}
window.addEventListener('load', (event) => {
    fbBindFilterDelegates();
    changeGridLayout();
    hideShowFilters();
    applyFilters();
});

jQuery(document).on("shopify:section:load shopify:section:unload", function (event) {
    layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
    layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
    layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
    layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
    hideShowFiltersEvent = false;
    filters = document.getElementById('filterSideBar');
    filterContainer = document.getElementById('CollectionProductsContainer');
    fbBindFilterDelegates();
    changeGridLayout();
    applyFilters();
    hideShowFilters();
})

var fbResizeTimer = null;
var fbLastWidth = window.innerWidth;
window.addEventListener('resize', function(event) {
    clearTimeout(fbResizeTimer);
    fbResizeTimer = setTimeout(function () {
        var w = window.innerWidth;
        if (w === fbLastWidth) { return; }
        var crossed = (fbLastWidth < 768 && w >= 768) || (fbLastWidth >= 768 && w < 768);
        fbLastWidth = w;
        changeGridLayout();
        hideShowFilters();
        sortByVisibilityChange();
        var filters = document.getElementById('filterSideBar');
        if (filters && crossed && w < 768) {
            filters.style.display = 'none';
            setTimeout(function() { filters.style.display = ''; }, 500)
        }
    }, 150);
});

function showMoreFilters() { /* fixes 71: handled by the delegated click listener (fbShowMoreClick) */ }
function fbShowMoreClick(e, showMoreFilter) {
    e.preventDefault();
    var more = showMoreFilter.parentNode.querySelector('.more-options');
    if (showMoreFilter.classList.contains('active')) {
        showMoreFilter.classList.remove('active');
        if (more) { DOMAnimations.slideUp(more, 150); }
        showMoreFilter.querySelector('span').textContent = showMoreText;
    } else {
        showMoreFilter.classList.add('active');
        if (more) { DOMAnimations.slideDown(more, 150); }
        showMoreFilter.querySelector('span').textContent = showLessText;
    }
}

function fbLayoutClick(e, layout) {
    e.preventDefault();
    var section = document.getElementById('CollectionProductsContainer');
    if (!section || layout.classList.contains('active')) { return; }
    var sectionParent = section.closest('.shopify-section');
    var layouts = sectionParent ? sectionParent.querySelectorAll('.sort-grid-icon') : [layout];
    layout.classList.add('active');
    let allGrids = section.querySelectorAll('.aos-init');
    Array.from(allGrids).forEach(function(grid) {
        grid.classList.remove('aos-animate');
        grid.classList.remove('aos-init');
    });
    setTimeout(function() {
        Array.from(layouts).forEach(function(layoutItem) {
            if (layoutItem != layout) {
                layoutItem.classList.remove('active');
            }
        });
        var _thisLayout = layout.dataset.value;
        section.setAttribute('data-view', _thisLayout)
        updateGridView(section);
        var date = new Date();
        date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
        Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
        let allImages = section.querySelectorAll('.lazyloaded');
        Array.from(allImages).forEach(function(image) {
            image.classList.remove('lazyloaded');
            image.classList.add('lazyload');
        });
    }, 800);
}

/* fixes 71: idempotent. Creates each price slider once and gives it one change handler; all other controls are delegated. */
function applyFilters() {
    fbBindFilterDelegates();
    var section = document.getElementById('CollectionProductsContainer');
    if (!section) { return false; }
    const filterForm = document.getElementById('FiltersForm');
    if (!filterForm || typeof noUiSlider === 'undefined') { return false; }
    var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
    Array.from(priceRangeBars).forEach(function(rangeBar) {
        var el = rangeBar;
        if (el.dataset.fbSliderBound === '1') { return; }
        el.dataset.fbSliderBound = '1';
        var slider = el.noUiSlider || noUiSlider.create(el, {
            step: 1,
            connect: true,
            start: [(parseFloat(el.dataset.start) || 0), parseFloat((el.dataset.end || el.dataset.max ))],
            range: {
                min: [parseFloat(el.dataset.min) || 0],
                max: [parseFloat(el.dataset.max) || 100]
            }
        });
        slider.on('change', function(values) {
            var sec = document.getElementById('CollectionProductsContainer');
            if (!sec) { return; }
            var minRange = parseFloat(el.dataset.min) || 0;
            var maxRange = parseFloat(el.dataset.max) || 100;
            var minVal = parseFloat(values[0]);
            var gte = sec.querySelector('input[name="filter.v.price.gte"]');
            var lte = sec.querySelector('input[name="filter.v.price.lte"]');
            if (gte && minVal >= minRange) { gte.value = minVal; }
            var maxVal = parseFloat(values[1]);
            if (lte && maxVal <= maxRange) { lte.value = maxVal; }
            if (window.innerWidth > 767) {
                getFilterData(rangeBar, fbFilterSectionId());
            }
        });
    });
}

function sortByOptions() { /* fixes 71: handled by the delegated change listener (fbSortChange) */ }
function fbSortChange(e, sort) {
    var section = document.getElementById('CollectionProductsContainer');
    if (!section) { return; }
    e.preventDefault();
    var sortBy = document.querySelectorAll('[name="sort_by"][data-sort-by]');
    Array.from(sortBy).forEach(function(s) {
        s.parentNode.classList.remove('selected');
    })
    sort.parentNode.classList.add('selected');
    var sortMenu = document.getElementById('sort__list');
    if(sortMenu){
        if (sortMenu.classList.contains('active')) {
            sortMenu.classList.remove('active');
            if (window.innerWidth > 767) {
                DOMAnimations.slideUp(sortMenu);
            } else {
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        }
    }
    document.querySelector('body').classList.remove('open-filter-sort');
    getFilterData(sort, section.dataset.id);
}
function sortByVisibilityChange(){
     var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
          if(sortList.classList.contains('active')){
            sortList.style.display = 'block';
          }else{
            sortList.style.display = 'none';
          }
          document.querySelector('body').classList.remove('open-filter-sort');          
        }else{
          sortList.style.display = 'block';
          if(sortList.classList.contains('active')){
            document.querySelector('body').classList.add('open-filter-sort');
          }else{
            document.querySelector('body').classList.remove('open-filter-sort');
          }
        }
    }
}
function sortBy() { /* fixes 71: handled by the delegated click listener (fbSortMenuToggle and .close-sort) */ }
function fbSortMenuToggle(e) {
    e.preventDefault();
    var sortMenu = document.getElementById('sort__list');
    if (!sortMenu) { return; }
    if (sortMenu.classList.contains('active')) {
        sortMenu.classList.remove('active');
        if (window.innerWidth > 767) {
            DOMAnimations.slideUp(sortMenu);
        } else {
            document.querySelector('body').classList.remove('open-filter-sort');
        }
    } else {
        sortMenu.classList.add('active');
        if (window.innerWidth > 767) {
            DOMAnimations.slideDown(sortMenu);
        } else {
            document.querySelector('body').classList.add('open-filter-sort');
        }
    }
}

function updateGridView(section) {
    if (section) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                if (_layout == 'grid-layout-2') {
                    item.setAttribute('class', layout2);
                } else if (_layout == 'grid-layout-3') {
                    item.setAttribute('class', layout3);
                } else if (_layout == 'grid-layout-4') {
                    item.setAttribute('class', layout4);
                } else if (_layout == 'grid-layout-5') {
                    item.setAttribute('class', layout5);
                }
            });
        }
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
    }
}

function fetchFilterData(url) {
    /* fixes 71: a newer filter request aborts the one still loading, so only the last tap updates the grid. */
    if (fbFilterCtrl) { try { fbFilterCtrl.abort(); } catch (err) {} }
    fbFilterCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    return fetch(url, fbFilterCtrl ? { signal: fbFilterCtrl.signal } : undefined)
        .then(response => response.text())
}

/* fixes 71: titles are toggled by the delegated click listener, so titles that arrive with a filter result work too. */

function getFilterData(input, sectionId, remove) {
    let allGrids = document.getElementById('CollectionProductsContainer').querySelectorAll('.aos-init');
    Array.from(allGrids).forEach(function(grid) { 
        grid.classList.remove('aos-animate');
        grid.classList.remove('aos-init');
    });
    let filterForm = document.getElementById('FiltersForm');
    const formData = new FormData(filterForm);
    var searchParameters = new URLSearchParams(formData).toString();
    var clearAll = document.getElementById('yv-applied-filter-cross-all');    
    var url = window.location.pathname + '?section_id=' + sectionId + '&' + searchParameters;
    var _updateUrl = window.location.pathname + '?' + searchParameters;
    if (remove) {
        url = remove;
        _updateUrl = remove;
    }
    var fbSeq = ++fbFilterSeq;
    const html = fetchFilterData(url).
    then((responseText) => {
        if (fbSeq !== fbFilterSeq) { return; }
        var fbWasOpen = fbFilterDrawerIsOpen();
        const resultData = new DOMParser().parseFromString(responseText, 'text/html');
        var itemResultCount = resultData.querySelector('.products-count');
        var sortByHtml = '';
        if (resultData.getElementById('toolbox-sort')) {
            sortByHtml = resultData.getElementById('toolbox-sort').innerHTML;
        }
        var html = resultData.getElementById('CollectionProductsContainer');
        var resultClear = resultData.getElementById('yv-applied-filter-cross-all')
        if (resultClear) {
            if (!document.getElementById('yv-applied-filter-cross-all')) {
                document.querySelector('.filter-heading-wrapper').appendChild(resultClear);
                clearAllFilterButton = true;
            }
          else{
            clearAllFilterButton = false;
          }
        }else{
            if (clearAll) {
                clearAll.remove();
                clearAllFilterButton = false;
            }
        }
        var elmnt = document.getElementById('CollectionProductsContainer');
        updateGridView(html);
        if (html) {
            elmnt.innerHTML = html.innerHTML;
        } else {
            let productResultContainer = elmnt.querySelector('[data-collection-products]');
            if (productResultContainer) {
                productResultContainer.innerHTML = noResultFound;
            }
        }
        document.querySelector('body').classList.remove('open-filter-sort');
        document.querySelector('body').classList.remove('open-filter-popup');
        filters = document.getElementById('filterSideBar');
        filterContainer = elmnt;
        let inputId = input.getAttribute('id');
        let updateInput = fbWasOpen ? null : document.getElementById(inputId);
        if (fbWasOpen) { fbFilterDrawerClose(true); }
        if (updateInput) {
            updateInput.focus();
            let moreOption = updateInput.closest('.more-options');
            if (moreOption) {
                moreOption.style.display = 'block';
                let moreOptionText = updateInput.closest('.yv-filter-content').querySelector('.filters-expand');
                if (moreOptionText) {
                    moreOptionText.classList.add('active');
                    moreOptionText.querySelector('span').innerHTML = showLessText;
                }
            }
        }
        if (itemResultCount) {
            document.querySelector('.products-count').innerHTML = itemResultCount.innerHTML;
        }
        if (document.getElementById('toolbox-sort')) {
            document.getElementById('toolbox-sort').innerHTML = sortByHtml;
        }
        applyFilters();
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
        productHoverSlider();
        if (input.getAttribute('name') != 'sort_by' && elmnt.closest('.yv-collection-container')) {
            elmnt.closest('.yv-collection-container').scrollIntoView({ top: 150, behavior: "smooth" });
        }
        /* Claude fixes 72 (P33 step 1): the URL keeps the filter/sort state without adding a history entry per tap. */
        try { history.replaceState(history.state, '', _updateUrl); } catch (err) {}
    }).catch(function (err) {
        if (err && err.name === 'AbortError') { return; }
        throw err;
    });
}

let triggered = false;
function ScrollExecute() {
    var moreButon = $('#more').last();
    var nextUrl = moreButon.find('a').attr("href");
    if (screenVisibility(moreButon) && (triggered == false)) {
        triggered = true;
        $.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function() {
                moreButon.find('.load').removeClass('hidden');
            }
        })
        .done(function(data) {
            moreButon.remove();
            var e = document.createElement('div');
            e.innerHTML = $(data).find('#CollectionProductsContainer').html();
            updateGridView(e)
            $('[data-collection-products]').append(e.querySelector('[data-collection-products]').innerHTML);
            productVariants();
            gridPickUpAvailability();
            productHoverSlider(); 
            if(animationStatus){
                if (AOS) { 
                AOS.refreshHard() 
                }
            }
            triggered = false
        });
    }
}
/* Claude fixes 72 (P33 step 2): infinite scroll runs from the one shared rAF scroll listener in common.js (window.fbOnScroll). */
if (window.fbOnScroll) {
    window.fbOnScroll(ScrollExecute);
} else {
    $(document).ready(function() {
        $(window).scroll(function() {
            ScrollExecute();
        });
    });
}